// extracted by mini-css-extract-plugin
export default {"titleGroup":"AlumniPelatihan_titleGroup__DK2jG","titleContainer":"AlumniPelatihan_titleContainer__nSiBs","imageContainer":"AlumniPelatihan_imageContainer__BF6nN"};